module.exports = __webpack_public_path__ + "static/img/five-tips-for-buying-a-car.32858fc.jpg";